<template>
    <div class="tabContent" id="links1">
        <div class="oldInnerWrapper">
            <div class="bold500">Web-Links erfassen</div>
            <div><a target="_blank" href="/project/sogehts/pinboard/sofunktionierts/show.html">Was ist damit gemeint?</a></div>
            <div style="margin-top: 20px;">Hinweis: Wenn du deinen Beitrag bereits als Embed-Code erfasst hast, musst du ihn nicht mehr als Web-Link einreichen.</div>

            <form v-for="(model, index) in externModels" :key="model">

                <div v-if="index > 0" class="clearfix">
                    <hr/>
                    <div style="float:right;" class="btn btn-white" @click.prevent="externModels.splice(index, 1)"><i class="fa fa-close"></i></div>
                </div>

                <select :name="'platform_ext_' + index" 
                        style="margin-top:20px" 
                        v-model="model.elements[1].text" 
                        v-validate="{rules: {'required': isExternPlatformRequired(model, index)}}" 
                        :class="{'error': errors.has('platform_ext_' + index)}">
                    <option value="">Plattform auswählen</option>
                    <option value="INSTAGRAM">Instagram</option>
                    <option value="FACEBOOK">Facebook</option>
                    <option value="PINTEREST">Pinterest</option>
                    <option value="TIKTOK">TikTok</option>
                    <option value="YOUTUBE">Youtube</option>
                    <option value="OWNBLOG">Eigener Blog</option>
                    <option value="SHOPS">Bewertungsplattformen & Shops</option>
                    <option value="OTHER">Sonstiges</option>
                </select>				
                
                <label style="margin-top:20px">Link</label> 
                <input :name="'link_ext_' + index" 
                        type="text" 
                        placeholder="URL zu deinem Post"
                        v-model="model.elements[2].text" 
                        v-validate="{rules: {'required': isExternLinkRequired(model, index), 'url': [true]}}" 
                        :class="{'error': errors.has('link_ext_' + index)}"
                        />			
                <p v-if="errors.has('link_ext_' + index + ':url')" class="errorText">
                    <strong>Das ist kein gültiger Web-Link. Gültige Web-Links müssen z.B. alle mit http:// oder https:// beginnen</strong>
                </p>
                
                <label style="margin-top:20px">Titel</label>
                <input :name="'title_ext_' + index" 
                        type="text" 
                        placeholder="Max. 90 Zeichen"
                        maxlength="90"
                        v-model="model.elements[3].text" 
                        v-validate="{rules: {'required': isExternTitleRequired(model, index)}}" 
                        :class="{'error': errors.has('title_ext_' + index)}"
                        />			
                
                <label style="margin-top:20px">Kurz-Beschreibung</label>
                <textarea :name="'description_ext_' + index" 
                        placeholder="Max. 145 Zeichen"
                        maxlength="145" 
                        v-model="model.elements[4].text" 
                        v-validate="{rules: {'required': isExternDescriptionRequired(model, index)}}" 
                        :class="{'error': errors.has('description_ext_' + index)}"></textarea>
            </form>    
            <button type="button" v-on:click="addExternLink" style="margin-top:20px" class="btn btn-white teaserButton width100">Weiteren Link hinzufügen</button>
            
                <hr/>
                
            <form>
                <div class="textAlignRight buttonBlockContainerRight">
                    <button type="button" v-on:click="cancel" class="btn btn-white teaserButton width50">Abbrechen</button>
                    <button type="button" v-on:click="save" class="btn btn-white teaserButton width50" :disabled="errors.any()">Speichern</button>
                </div>
            </form>
        </div>
        <!-- Modal -->
        <div ref="modalDialog" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog old-modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Speichern fehlgeschlagen</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Deine Eingabe war leider nicht gültig und kann nicht gespeichert werden.
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">OK</button>
                </div>
                </div>
            </div>
        </div>
    </div><!-- end links1 -->
</template>

<script>
    import { Validator } from 'vee-validate';
	export default {
		name: 'userContentLinks',
		props: {
            project: String,
            contentkey: String
        },
        data: function() {
        	return {
                inSave: false,
                externModels: [{
                    id: null,
                    type: 'links',
                    elements: [
                    {
                        id: null,
                        kind: 'text',
                        type: 'linkstype',
                        text: 'external'
                    },
                    {
                        id: null,
                        kind: 'text',
                        type: 'linksplatform',
                        text: ''
                    },
                    {
                        id: null,
                        kind: 'text',
                        type: 'linkslink',
                        text: null
                    },
                    {
                        id: null,
                        kind: 'text',
                        type: 'linkstitle',
                        text: null
                    },
                    {
                        id: null,
                        kind: 'text',
                        type: 'linksdescription',
                        text: null
                    }
                    ]
                }],
                templateExternModel: null
        	}
        },
        created: function() {
            this.templateExternModel = jQuery.extend(true, {}, this.externModels[0]);
            var self = this;
            Validator.extend('embeddedLink', {
                getMessage(field, args, data) {
                    return data.message;
                },
                validate(value, args) {
                    var platform = args[0].elements[1].text;
                    if (platform == '') {
                        return true;
                    }
                    return jQuery.ajax({
                        url: '/project/' + self.project + '/validate',
                        type: 'POST',
                        dataType: 'json',
                        data: JSON.stringify(args[0]),
                        contentType: "application/json; charset=utf-8"}).then(function(response) {
                        return {
                            valid: response,
                            data: {
                                message: 'das ist ein Test'
                            }
                        };
                    });
                }
            });
            if (this.contentkey) {
                this.load();
            } else {
            }
        },
        methods: {
            cancel: function() {
                console.log('cancel clicked');
                this.$emit('cancel');
                return false;
            },
            addExternLink: function() {
                this.externModels.push(jQuery.extend(true, {}, this.templateExternModel));
                console.log('added extern link');
            },
            isExternPlatformRequired: function(model, index) {
                if (index == 0) {
                    if (model.id && model.id != '') {
                        return true;
                    }
                    if (model.elements[2].text && model.elements[2].text != '') {
                        return true;
                    }
                    if (model.elements[3].text && model.elements[2].text != '') {
                        return true;
                    }
                    if (model.elements[4].text && model.elements[4].text != '') {
                        return true;
                    }
                    return false;
                }
                return true;
            },
            isExternLinkRequired: function(model, index) {
                if (index == 0) {
                    if (model.id && model.id != '') {
                        return true;
                    }
                    if (model.elements[1].text && model.elements[1].text != '') {
                        return true;
                    }
                    if (model.elements[3].text && model.elements[3].text != '') {
                        return true;
                    }
                    if (model.elements[4].text && model.elements[4].text != '') {
                        return true;
                    }
                    return false;
                }
                return true;
            },
            isExternTitleRequired: function(model, index) {
                if (index == 0) {
                    if (model.id && model.id != '') {
                        return true;
                    }
                    if (model.elements[1].text && model.elements[1].text != '') {
                        return true;
                    }
                    if (model.elements[2].text && model.elements[2].text != '') {
                        return true;
                    }
                    if (model.elements[4].text && model.elements[4].text != '') {
                        return true;
                    }
                    return false;
                }
                return true;
            },
            isExternDescriptionRequired: function(model, index) {
                if (index == 0) {
                    if (model.id && model.id != '') {
                        return true;
                    }
                    if (model.elements[1].text && model.elements[1].text != '') {
                        return true;
                    }
                    if (model.elements[2].text && model.elements[2].text != '') {
                        return true;
                    }
                    if (model.elements[3].text && model.elements[3].text != '') {
                        return true;
                    }
                    return false;
                }
                return true;
            },
            load: function() {
                var self = this;
                jQuery.ajax ({
                    url: '/project/' + self.project + '/content/' + self.contentkey,
                    type: 'GET',
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        if (data.elements[0].text == 'external') {
                            console.log('loaded external link');
                            self.externModels = [jQuery.extend(true, {}, data)];
                            console.log(self.externModels); 
                        }
                    },
                    error: function() {alert("error");}
                });
            },
            save: function() {
                if (this.inSave) {
                    return;
                }
                var self = this;
                this.$validator.validateAll().then(function(result) {
                    if (self.errors.any()) {
                        return;
                    }
                    self.inSave = true;
                    var selfModels = [];
                    if (self.externModels.length > 1 || self.externModels[0].elements[1].text != '') {
                        self.externModels.forEach(function(externModel) {
                            selfModels.push(jQuery.extend(true, {}, externModel));
                        });
                    }
                    if (selfModels.length === 0) {
                        return;
                    } 
                    jQuery.ajax ({
                        url: '/project/' + self.project + '/contents',
                        type: 'POST',
                        dataType: 'json',
                        data: JSON.stringify(selfModels),
                        contentType: "application/json; charset=utf-8",
                        success: function(data) {
                            window.location.href = '/project/' + self.project + '/content.html';
                        },
                        error: function(data) {
                            jQuery(self.$refs.modalDialog).modal('show');
                        }
                    });
                });
            }
        }
	}
</script>


// WEBPACK FOOTER //
// UserContentLinks.vue?37c3ae7a